/**
 * Oprávnění modulu VenuaPlanner (zrcadlí backend `VenuaPlannerPermissions.Agenda`).
 * Jeden uzel katalogu s úrovněmi: `read` = zobrazení agendy (menu, gate), `edit` = úpravy.
 */
export const VENUA_PLANNER_PERMISSION = 'products.venua-planner';

/** Oprávnění agendy Knihovna placeholderů (zrcadlí backend `SchemasPermissions.Placeholders`). */
export const VENUA_PLANNER_PLACEHOLDERS = 'products.placeholders';

/** Oprávnění agendy Subkategorie placeholderů (zrcadlí backend `SchemasPermissions.Subcategories`). */
export const VENUA_PLANNER_PLACEHOLDER_SUBCATEGORIES = 'products.placeholder-subcategories';
